import React, { Component } from 'react';
import { ItemDetails, ModalLayout } from '../';
import {getTransformationUrl} from './../../../utils/helper';
import styles from './styles.scss';

export default class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      multiPrintQty: props.item.po_qty,
    };
  }
  scrimClick = () => {
    this.setState({showModal:false})
  }
  getImage = (item) => {
    return item.image_key ? getTransformationUrl(item.image_key) : item.image;
  }
  renderImageLayoutBox = (item) => {
    return (
      <div className={styles.productBox} key={item.partner_sku}>
        <div className={styles.imageContainer} onClick={() => this.setState({ showModal: true })}>
          <div className="imagePreloader">
            <img src={this.getImage(item)} alt={item.title_en} />
          </div>
        </div>
        <div className={styles.detailsContainer}>
          <p className={styles.brand}>{item.brand_code}</p>
          <p className={styles.title}>{item.title_en}</p>
          <p><span className={styles.helper}>Variant:</span> {item.variant_en}</p>
          <p className={styles.sku}>{item.gtin}</p>
          <p className={styles.sku}>{item.sku}</p>
          <p className={styles.sku}>{item.partner_sku}</p>
          <div className={styles.ctaContainer}>
            <button
              onClick={() => this.setState({ showModal: true })}
              className={styles.secondaryCta}
            >
              Multi Print<i className="icon-copy" />
            </button>
            <button className={styles.primaryCta} onClick={() => this.props.printLabel([item])}>Quick Print</button>
          </div>
        </div>
      </div>
    );
  }

  renderTableLayoutBox (item) {
    return (
      <div className={styles.productRow} key={item.partner_sku}>
        <div className={styles.imageContainer} onClick={() => this.setState({ showModal: true })}>
          <div className="imagePreloader">
            <img src={getTransformationUrl(item.image_key)} alt={item.title_en} />
          </div>
        </div>
        <p className={styles.brand} onClick={() => this.setState({ showModal: true })}>{item.brand_code}</p>
        <p className={styles.title} onClick={() => this.setState({ showModal: true })}>{item.title_en}</p>
        <p onClick={() => this.setState({ showModal: true })}><span className={styles.helper}>Variant:</span> {item.variant_en}</p>
        <p className={styles.sku} onClick={() => this.setState({ showModal: true })}>{item.gtin}</p>
        <p className={styles.sku} onClick={() => this.setState({ showModal: true })}>{item.sku}</p>
        <p className={styles.sku} onClick={() => this.setState({ showModal: true })}>{item.partner_sku}</p>
        <div className={styles.ctaContainer}>
          <button className={styles.primaryCta} onClick={() => this.props.printLabel([item])}>Quick Print</button>
          <button onClick={() => this.setState({ showModal: true })} className={styles.secondaryCta}>
              Multi Print<i className="icon-copy" />
          </button>
        </div>
      </div>
    );
  }
  filtered = (item) => {

  }

  render () {
    const { item, layout } = this.props;
    const printOption= <React.Fragment>
      <div className={styles.printControls}>
        <input
          value={this.state.multiPrintQty}
          onChange={(e) => { this.setState({ multiPrintQty: e.target.value })}}
        />
        <button className={styles.primaryCta} onClick={() => this.props.printLabel( [{...item, qty: this.state.multiPrintQty}] )}>Print Multiple</button>
      </div>
    </React.Fragment>
    return (
      <React.Fragment>
        {/* PRODUCT */}
        {layout === 'table' ? this.renderTableLayoutBox(item) : this.renderImageLayoutBox(item)}
        {/* MULTI PRINT VIEW */}
        {this.state.showModal &&
          <ModalLayout width="700px" scrimClick={() => this.scrimClick(false)}>
           {ItemDetails(item, printOption)}
          </ModalLayout>}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ProductBox/index.js